module.exports = __webpack_public_path__ + "static/ScreensPreviews-80c5cae1f67c097618274cd146595dea.png";